import styled from "styled-components";

const menuShadow =
  "0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.2)";

export const SelectRoot = styled.div`
  position: relative;
  width: 100%;
`;

export const SelectTrigger = styled.button<{ $readOnly?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  padding: 0 0 0 12px;
  border: 1px solid
    ${({ $readOnly }) => ($readOnly ? "#e7e8ec" : "#ceced2")};
  border-radius: 5px;
  background: ${({ $readOnly }) => ($readOnly ? "#f7f8fa" : "#fff")};
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.5px;
  color: ${({ $readOnly }) => ($readOnly ? "#5e5e60" : "#383839")};
  cursor: ${({ $readOnly }) => ($readOnly ? "default" : "pointer")};
  text-align: left;

  &:disabled {
    background: ${({ $readOnly }) => ($readOnly ? "#f7f8fa" : "#fff")};
    border-color: ${({ $readOnly }) => ($readOnly ? "#e7e8ec" : "#ceced2")};
    color: ${({ $readOnly }) => ($readOnly ? "#5e5e60" : "#383839")};
    cursor: ${({ $readOnly }) => ($readOnly ? "default" : "not-allowed")};
    opacity: 1;
  }
`;

export const SelectValue = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SelectIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
`;

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 1000;
  width: 100%;
  overflow: hidden;
  border-radius: 4px;
  background: #fff;
  box-shadow: ${menuShadow};
`;

export const OptionList = styled.ul`
  max-height: 280px;
  margin: 0;
  padding: 8px 0;
  overflow-y: auto;
  list-style: none;
`;

export const OptionItem = styled.li<{ $selected?: boolean; $active?: boolean }>`
  padding: 6px 16px;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.15px;
  color: #383839;
  cursor: pointer;
  background: ${({ $selected, $active }) =>
    $selected || $active ? "rgba(0, 0, 0, 0.04)" : "transparent"};

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
`;

export const EmptyOption = styled.li`
  padding: 6px 16px;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #5e5e60;
`;
